<div class="text-gray-700 mb-1 block font-medium">{{ label() }}</div>

<div class="flex flex-col gap-4">
  <div class="flex gap-2">
    @for (index of indices; track $index) {
      <input
        id="code-input-{{ index }}"
        [value]="inputs[index]()"
        (input)="onInput($event, index)"
        (keydown)="onKeyDown($event, index)"
        (paste)="onPaste($event)"
        maxlength="1"
        [class.bg-red-5]="!isValid[index]()"
        class="border-gray-300 h-8 w-8 rounded border text-center font-mono text-xl uppercase placeholder-gray-8 placeholder:text-sm focus:ring-2 focus:ring-primary focus:outline-none"
        placeholder="{{ index < 6 ? '0-9' : 'A-Z' }}"
      />
    }
  </div>
  <div class="flex gap-2">
    <div>Vous n'avez pas reçu de code ?</div>
    <button mat-button class="link" [disabled]="isDisabled()" (click)="onResend()">
      {{ buttonLabel() }}
    </button>
  </div>
</div>
